// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__sIdzk","mobileSearchButton":"styles_mobileSearchButton__23f__"};